<template>
	<div class="VideoDetailsBox">
		<!--视频盒子-->
		<div class="VideoCententMaxBox">
			<div class="VideoCententUl" @touchstart='touchstart' @touchend='touchend'>
				
				<div class="VideoCententBox" v-bind:style="getVideoboxStyle" v-for="(item,index) in VideoDetail" :key="index">
					
					
					
					<!--视频-->
					<div class="VideoBoxs" :id="videoheight+index" :videoids="item.video_info.svideo_id" :stopids="item.man_info.store_id">
						<video v-if="userAgent==false" loop="loop" muted="muted" autoplay="autoplay" controls="controls" x5-playsinline="" playsinline="true" webkit-playsinline="true"  controlslist="nodownload nofullscreen noremoteplayback noplaybackrate" :src="item.video_info.svideo_url" :id="videoPlayss+index" ref="videoPlay">Your browser does not support video elements     >_<</video>
						
						<video v-else loop="loop" autoplay="autoplay" controls="controls" x5-playsinline="" playsinline="true" webkit-playsinline="true"  controlslist="nodownload nofullscreen noremoteplayback noplaybackrate" :src="item.video_info.svideo_url" :id="videoPlayss+index" ref="videoPlay">Your browser does not support video elements     >_<</video>
					</div>
					
					<!--视频右侧菜单栏-->
					<div class="VideoOperation" :id="videobottom+index">
						<!--相关产品-->
						<div class="RelatedProductsBox" v-if="item.goods_list.length>0">
							<div class="ProductsContentBox">
								<div class="goodslists click" v-for="(goodsitem, goodsindex) in item.goods_list" @click="goproduct(goodsitem.goods_id)">
									<div class="ProductsImg">
										<img :src="goodsitem.goods_image" />
									</div>
									<div class="ProductsTextBox">
										<h3>{{goodsitem.goods_name}}</h3>
										<p>${{goodsitem.goods_price}}</p>
									</div>	
								</div>
							</div>
						</div>
						<!--相关产品 end-->
						
						<!--标题-->
						<div class="VideoTitlesBox">
							<div class="VideoHeaderTopTexts">
								<h3>
									<p>{{item.video_info.svideo_name}}</p>
									<span v-for="(tag, tagindex) in item.tag_list">#{{tag.svideotag_name}}</span>
								</h3>
							</div>
						</div>
						<!--标题 end-->
						
						<!--操作栏-->
						<div class="videobottomsBox">
							<!--达人信息-->
							<div class="VideoUserBox">
								<div class="ViderUserImg click" @click="godarenindex(item.man_info.svideoman_id)">
									<img :id="imgheight+index" class="svideoman_pics" :src="item.man_info.svideoman_pic" />
								</div>
								<div class="VideoUserBoxname">
									<p class="click" @click="godarenindex(item.man_info.svideoman_id)">{{item.man_info.svideoman_name}}</p>
									<span v-if="item.is_focus==0" class="jionboxs click" @click="gofollow(item.man_info.svideoman_id,index)">+Follow</span>
									<span v-else class="cleadjionboxs click" @click="CancelFollow(item.man_info.svideoman_id,index)">Followed</span>
								</div>
								
							</div>
							
							<!--店铺、评论、点赞-->
							<div class="OperationList">
								<ul>
									<li class="click" @click="goShopDetail(item.man_info.store_id)">
										<img src="../../../assets/image/video/hime.png" />
										<!--<p>Shop</p>-->
									</li>
									
									<li class="click" @click="showComment(item.video_info.svideo_id,index)">
										<img src="../../../assets/image/video/videopingl.png" />
										<p v-if="item.message_list.length==0"></p>
										<p style="display: none;" v-else>{{item.message_list.length}}</p>
									</li>
									
									<li class="click" @click="Videolike(item.man_info.svideoman_id,item.video_info.svideo_id,index)">
										<img v-if="item.is_like==0" src="../../../assets/image/video/videoxin.png" />
										<img v-else src="../../../assets/image/video/videoxin-red.png" />
										<!--<p v-if="item.like_num==0">Like</p>-->
										<p style="display: none;" v-else>{{item.like_num}}</p>
									</li>
								</ul>
							</div>	
						</div>
						
						
						
						
						
						<div class="VideoHeaderTop click" @click="$router.go(-1)">
							<img src="../../../assets/image/video/xleft.png" />
						</div>
						<div class="VideoHeadershare click" @click="videoshare">
							<img src="../../../assets/image/video/share.png" />
							<p></p>
							<input id="copycode" readonly="readonly" type="text" v-model="inviteCode" />
						</div>
						
						<div class="goauthorization">
							<p>Reproducing this video requires authorization from the author</p>
						</div>
					</div>
					
					<!--评论-->
					<div class="VideoCommentBox" :class="{active:comments==item.video_info.svideo_id}">
						<div class="VideoCommentHeader">
							<p>{{item.message_list.length}} comment</p>
							<img class="click" @click="closeck" src="../../../assets/image/video/close.png" />
						</div>
						<div class="VideoCommentListBox">
							<ul :id="VideoCommentBoxs+index">
								<li v-for="(msgitem,msgindex) in item.message_list">
									<div class="CommentHeader">
										<img :src="msgitem.instant_message_from_avatar" />
									</div>
									
									<div class="CommentUserBox">
										<h6>{{msgitem.instant_message_from_name}}</h6>
										<p>{{msgitem.instant_message}}</p>
									</div>
								</li>
								
							</ul>
						</div>
						<div class="CommentInputBox">
							<div class="CommentInputContent">
								<input type="text" placeholder="Add a Comment" v-model="commenttext" />
								<span class="click" @click="gocomment(item.video_info.svideo_id,index)">Send</span>
							</div>
						</div>
					</div>
					<!--评论 end-->
					
					<!--透明度背景-->
						<div class="TransparencyBack click" @click="closeck" v-show="back"></div>	
					<!--透明度背景 end-->
					
				</div>
			</div>
			
			
		</div>
		<!--视频盒子-->
		
		
		
		
	</div>
</template>

<script>
	import { getVideoDetail,getVideoMessage,getbeFans,getcancelFocus,getVideolike,getVideoplayList} from '../../../api/video'
	import { mapState } from 'vuex'
	import { Toast } from 'mint-ui'
	import { loadScript } from '../../../util/common'
	import { getbuyerview} from '../../../api/common'
export default {
  name: 'video_Detail',
  data () {
    return {
      videoid:this.$route.query.videoid,
      listindex:1,
      listids:[],
      pages:this.$route.query.pages,
      types:this.$route.query.type,
      back:false,
      comments:"",
      related:"",
      inviteCode:"",
      relatedvideo:"",
      commenttext:"",
      member_id:"",
      videoPlayss:"videoPlayss",
      videoheight:"videoheight",
      videobottom:"videobottom",
      imgheight:"imgheight",
      VideoCommentBoxs:"VideoCommentBoxs",
      VideoDetail:[],
      userAgent:true,
      startY:"",
      moveY:"",
      heightss:"",
      totalheight:0,
      totallen:"",
      nextpages:true,
      heightlen:"",
      dqn:0,
      videoElement: [],
      frequency:1,
      dates:"",
      enddates:"",
      home_url:"",
      svideoclass:"",
      videoids:"",
      stopids:"",
    }
  },
  
  components: {
    ...mapState({
    	isOnline: state => state.member.isOnline,
    	user: state => state.member.info,
    	
    })
   
  },
  mounted () {
	window.addEventListener('beforeunload', (event) => {
      if(this.user){
    		this.buyerview();
    	}
    });
  },
  created: function () {
  	//获取localStorage，如果用户是第一次使用，提示方法
    var firstval=localStorage.getItem("firstval");
	if(!firstval){
		localStorage.setItem("firstval","videovalue");
		Toast("Swipe your finger up the screen to see the next video")
	}
  	
  	if(this.user){
  		this.member_id=this.user.member_id;
  	}
  	if(this.pages==0){this.pages=1}
  	this.inviteCode="https://h5.duoyp.com/home/video_details?videoid="+this.videoid;
	getVideoDetail(this.videoid,this.member_id).then((res) => {
		if(res.code==10000){
			this.VideoDetail= this.VideoDetail.concat(res.result);
			this.videoplays();
			this.setVideo();
		}	
   	})
	//兼容微信滑动事件
	document.body.addEventListener('touchmove',this.isScroll, {passive: false}); 
	
	//微信自动播放
	loadScript('weixin','https://res.wx.qq.com/open/js/jweixin-1.2.0.js', function (){
		  document.addEventListener("WeixinJSBridgeReady",
			  function() {
			    setTimeout(() => {
			      document.getElementsByTagName("video")[this.dqn].play();
			    }, 500);
			  },
			false
		);     
	})
   //微信自动播放 end
   
   
   //判断是ios打开还是安卓打开
    let ua = navigator.userAgent.toLowerCase();
    let isAndroid = ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1; 
    let isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);  
    if(/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
        //ios
		this.userAgent=false;
    }else{
        //android
        this.userAgent=true;
    }       
    //判断是ios打开还是安卓打开 end
    
    this.dates=Date.parse(new Date());
    this.home_url=window.location.protocol+"//"+window.location.host+"/home/video_details?videoid=";
  },
  //跳转离开页面时
  destroyed() {
  	if(this.user){
		this.buyerview();
    }
//      window.event.returnValue = true;
    document.body.removeEventListener("touchmove",this.isScroll);
  },
  computed: {
    ...mapState({
    	isOnline: state => state.member.isOnline,
    	user: state => state.member.info,
    	token: state => state.member.token,
    }),
    //获取屏幕高度
    getVideoboxStyle:function(){
    	this.heightss=document.documentElement.clientHeight;
    	return {
        	height: this.heightss + 'px'
        }
	}
  },
  methods: {
  	setVideo(n) {
	    let that = this
	    var i=1;
	    var videos = document.getElementsByTagName('video');
	    var videoman_pic=document.getElementsByClassName('svideoman_pics')
	    this.$nextTick(function () {
			videos[this.dqn].play();	
	        for (var i = 0; i <videos.length; i++) {
	        	var divheight = document.getElementById("videobottom"+[i]);
	        	var divheighttotal= divheight.offsetHeight;
	        	var videoheight = document.getElementById("videoheight"+[i]);
	        	videoheight.style.height= this.heightss-divheighttotal+"px"
	        	if(i!=this.dqn){
	        		videos[i].pause()
	        	}
	        	//处理头像
	        	var imgheight = document.getElementById("imgheight"+[i]);
	        	var imgheightSrc=imgheight.getAttribute("src")
	        	let imgObj = new Image()
        		imgObj.src = imgheightSrc
	        	imgObj.onload = () => {
		          if(imgObj.width>imgObj.height){
		          	imgheight.style.height="100%";
		          }else{
		          	imgheight.style.width= "100%";
		          }
		          imgheight.style.marginLeft="-"+imgheight.width/2+"px";
		        }
	        	//处理头像 end
	        }

	    })   
	},
	isScroll:function(){
		event.preventDefault();
	},
  	//获取视频详情数据
  	getvideodetailslist:function(videoidids){
  		getVideoDetail(videoidids,this.member_id).then((res) => {
		if(res.code==10000){
				this.VideoDetail= this.VideoDetail.concat(res.result);
//				this.setVideo()
			}	
	   	})
  	}, 	
  	
	//获取将要播放的视频ID
	videoplays:function(){
		getVideoplayList(this.videoid,this.pages,this.types).then((res) => {			
			if(res.code==10000){
				if(res.result.next_list.length!=0){
					for(var i=0;i<res.result.next_list.length;i++){
						if(res.result.next_list[i].svideo_id==this.videoid){
							this.listindex=i+1;
							break;
						}
					}	
					this.listids=this.listids.concat(res.result.next_list);
					this.totallen=this.listids.length-1;
					this.heightlen=this.listids.length-this.listindex;
					if(this.frequency==1){
						this.getvideodetailslist(this.listids[this.listindex].svideo_id)
					}
					this.frequency=2;
				}else{
					this.nextpages=false;
				}
				
			}	
	   	})
	},
  	//关注
  	gofollow:function(svideoman_id,index){
		if(this.isOnline){
	  		getbeFans(svideoman_id,this.user.member_id).then((res) => {
				
				
				if(res.code==10000){
					this.VideoDetail[index].is_focus=1;
					Toast("Focus on success");
				}else{
					Toast("Focus on failure");
				}

		  }).catch(function (error) {
		        Toast(error.message)
		    })
		}else{
			var redirecturl = window.location.href;
	  		this.$router.push({ name: 'HomeMemberLogin', query: { clear: 1 ,redirecturl:redirecturl} })
		}
  		
  	},
  	//取消关注
  	CancelFollow:function(svideoman_id,index){
  		if(this.isOnline){
	  		getcancelFocus(svideoman_id,this.user.member_id).then((res) => {
				
				if(res.code==10000){
					this.VideoDetail[index].is_focus=0;
					Toast("Cancel the following successfully");
				}else{
					Toast("Failed to cancel the following");
				}

		   }).catch(function (error) {
		        Toast(error.message)
		    })
		}else{
			var redirecturl = window.location.href;
	  		this.$router.push({ name: 'HomeMemberLogin', query: { clear: 1 ,redirecturl:redirecturl} })
		}
  	},
  	//点赞视频
  	Videolike:function(svideoman_id,videoid,index){
  		if(this.isOnline){
	  		getVideolike(this.user.member_id,svideoman_id,videoid).then((res) => {
	  			Toast(res.message);
				if(res.code==10000){
					this.VideoDetail[index].like_num=this.VideoDetail[index].like_num+1;
					this.VideoDetail[index].is_like=1;
				}
	  		}).catch(function (error) {
		        Toast(error.message)
		    })
  		}else{
  			var redirecturl = window.location.href;
	  		this.$router.push({ name: 'HomeMemberLogin', query: { clear: 1 ,redirecturl:redirecturl} })
  		}
  	},
  	//发送评论
  	gocomment:function(videoids,index){
  		if(this.isOnline){
	  		if(this.commenttext.length<=0){
	  			Toast("Add a Comment");
	  		}else{
	  			
		  		getVideoMessage(videoids,this.commenttext,3,0,this.member_id,this.token).then((res) => {
					Toast(res.message);
					if(res.code==10000){
						this.commenttext="";
						this.VideoDetail[index].message_list=this.VideoDetail[index].message_list.concat(res.result.instant_message_data);
						setTimeout(() => {
			        		document.getElementById("VideoCommentBoxs"+index).scrollTop = document.getElementById("VideoCommentBoxs"+index).scrollHeight;
			    		}, 300);
					
					}else{
						
					}
			    	
			    })	
	  		}	
  		}else{
  			var redirecturl = window.location.href;
	  		this.$router.push({ name: 'HomeMemberLogin', query: { clear: 1 ,redirecturl:redirecturl} })
  		}
  	},
  	//去短视频
  	govideolist:function(goods_id){
  		this.$router.push({ name: 'HomeVideoList'})
  	},
  	//去商城
  	goindexhome:function(){
  		this.$router.push({ name: 'HomeIndex',query:{lang:'en'}})
  	},
  	//产品详情
  	goproduct:function(goods_id){
  		this.$router.push({ name: 'HomeGoodsdetail', query: { goods_id: goods_id } })
  	},
  	//视频详情
	govideo:function(videoids){
		this.$router.push({ name: 'HomeVideoDetails', query: { videoid: videoids } })
		this.$router.go(0);
	},
	//关闭评论，视频=窗口
	closeck:function(){
	  this.back=false;
      this.comments="";
      this.related="";
      this.relatedvideo="";
      this.setVideo();
	},
	//显示评论
	showComment:function(commentsval,index){
		this.back=true;
		this.comments=commentsval;
		var videoheight = document.getElementById("videoheight"+[index]);
	    videoheight.style.height= this.heightss-320+"px"
	},
	
	//去达人主页
	godarenindex:function(svideoman_id){
		this.$router.push({ name: 'HomeVideoIndex', query: { svideoman_id: svideoman_id } })
	},
	touchstart (e) {
	// 如果你要阻止点击事件，请反注释下一行代码
    // e.preventDefault()
     this.startY = e.touches[0].clientY
  },
   touchend (e) {
// 	this.closeck();
    this.moveY = e.changedTouches[0].pageY
     if (this.moveY - this.startY < -30) {
     	if(this.totalheight==this.totallen*this.heightss){
     		Toast("No more");
     	}else{
     		//发送统计
     		this.svideoclass = document.getElementById("videoheight"+this.dqn);
     		this.videoids=this.svideoclass.getAttribute("videoids");
			this.stopids=this.svideoclass.getAttribute("stopids");
			this.buyerview();
     		
     		if(this.totallen==this.listindex){
	     		this.myRun();
	     	}else{
	     		this.myRun();
	     		this.listindex=this.listindex+1;
	     		this.getvideodetailslist(this.listids[this.listindex].svideo_id)
	     	}
	     	
	     	this.dqn=this.dqn+1;
	     	
	     	//上
	     	if(this.totallen==this.listindex && this.nextpages==true){
	     		this.pages=this.pages+1
	     		this.videoplays()
	     	}
     	}
     	this.setVideo()
	}else if(this.moveY - this.startY >30){
		//发送统计
		this.svideoclass = document.getElementById("videoheight"+this.dqn);
		this.videoids=this.svideoclass.getAttribute("videoids");
		this.stopids=this.svideoclass.getAttribute("stopids");
		this.buyerview();
		
		
		this.dqn=this.dqn-1;
		if(this.dqn<=0){
			this.dqn=0;
		}
		
		//下
		this.myRunlower();
		this.setVideo()
	}else{
		//幅度太小
	}
	//this.dqn+1后重新获取一次ID，以防用户跳转其他页面，获取不到新的数据-发送统计
	this.svideoclass = document.getElementById("videoheight"+this.dqn);
	this.videoids=this.svideoclass.getAttribute("videoids");
	this.stopids=this.svideoclass.getAttribute("stopids");
	
	var videoids=this.listids[this.dqn].svideo_id;
	if(videoids==""){
		videoids=this.$route.query.videoid
	}
	this.inviteCode="https://h5.duoyp.com/home/video_details?videoid="+videoids;
	
   },
//  向上滑动
	myRun:function(){
		var ai=0;
		var top=this.heightss/10;
		var num=this.heightss;
		var maxnum=this.totalheight;
		this.totalheight=this.totalheight+this.heightss;
		var box = document.querySelector('.VideoCententUl')
		var myInter = setInterval(function(){
			if(ai>=num){
				clearInterval(myInter);
			}else{
				ai=(ai*10+top*10)/10;
				var totals=maxnum*1+ai
				box.style.marginTop = '-'+totals+'px';
			}
		},20)
	},
//	向下滑动
	myRunlower(){
		var ai=this.heightss;
		var top=this.heightss/10;
		var maxnum=this.totalheight;
		this.totalheight=this.totalheight-this.heightss;
		if(this.totalheight<=0){
			this.totalheight=0;
		}
		var box = document.querySelector('.VideoCententUl')
		var myInter = setInterval(function(){
			if(ai<=0){
				clearInterval(myInter);
			}else{
				ai=(ai*10-top*10)/10;
				var totals=(maxnum*10-top*10)/10
				maxnum=(maxnum*10-top*10)/10;
				box.style.marginTop = '-'+totals+'px';
			}
		},20)
	},
	//分享
	videoshare:function(){		
		document.getElementById('copycode').select();
  		document.execCommand("Copy");
  		document.activeElement.blur();
		Toast('Successfully copied video link！')
	},
	//店铺
    goShopDetail(store_id) {
    	if(store_id){
    		this.$router.push({ 'name': 'HomeStoredetail', 'query': { 'id': store_id } })
    	}else{
    		Toast("The talent hasn't bound the store yet")
    	}
    	  
    },
     //发送统计
  	buyerview:function(){
    	this.enddates=Date.parse(new Date());
		this.enddates=(this.enddates-this.dates)/1000;
		if(this.enddates<1){
		  	this.enddates=1;
		}else if(this.enddates>3600){
		  	this.enddates=3600;
		}  
		if(this.stopids!="" && this.stopids!=0){
		   getbuyerview(this.user.member_id,this.home_url+this.videoids,this.enddates,"2",this.stopids).then((res)=> {
		   		this.dates=Date.parse(new Date());
		   })
		}
    }
  }
}	


</script>


<style scoped>
	.VideoCententUl{height: 100vh;height: 100000px;overflow: auto;overflow-y: scroll;overflow-x: hidden;-webkit-overflow-scrolling: touch;}
	.VideoDetailsBox{}
	.VideoHeaderTop{display: inline-block;width: 1.2rem;position: absolute;z-index: 1000;left: 0rem;bottom: 1.2rem;cursor: pointer;}
	.VideoHeaderTop img{width: 100%;}
	.VideoHeadershare{display: inline-block;width: 1.5rem;position: absolute;z-index: 1000;right: 0.1rem;bottom: 1.25rem;cursor: pointer;overflow: hidden;text-align: right;}
	.VideoHeadershare img{width: 80%;}
	.VideoHeadershare #copycode{width: 1px;height: 1px;right: -5rem;position: fixed;top: -1rem;}
	.VideoHeadershare p{margin: 0;font-size: 0.4rem;line-height: 0.5rem;color: #999;margin-top: 0.1rem;}
	.VideoCententMaxBox{position: fixed;left: 0px;top: 0px;width: 100%;height: 100%;box-sizing: border-box;z-index: 999;overflow: hidden;background: #000;}
	.VideoBoxs{position: absolute;left: 0px;top: 0px;width: 100%;height: 50%;z-index: 1;}
	.VideoCententBox{position: relative;width: 100%;box-sizing: border-box;}
	.VideoBoxs video{width: 100%;height: 100%;background-color: #000;box-sizing: border-box;}
	.VideoOperation{position: absolute;right: 0rem;bottom: 0rem;z-index: 10;box-sizing: border-box;width: 100%;padding: 0.1rem 0.2rem;background-image: linear-gradient(to top, #000, transparent);}
	.videobottomsBox{position: relative;padding: 0 1.3rem;overflow: auto;}
	.VideoUserBox{display: inline-block;width: 60%;float: left;overflow: auto;}
	.ViderUserImg{display: inline-block;box-sizing: border-box;vertical-align: middle;width: 1.8rem;height: 1.8rem;line-height: 1.5rem;border-radius: 50%;border: 1px solid transparent;text-align: center;overflow: hidden;float: left;margin-top: 0.1rem;position: relative;}
	.VideoUserBoxname{display: inline-block;float: left;max-width: calc(100% - 2.1rem);display: inline-block;overflow: auto;line-height: 2rem;box-sizing: border-box;position: relative;padding-right: 2.6rem;margin-left: 0.1rem;min-height: 2rem;}
	.VideoUserBoxname p{font-size: 0.6rem;color: #fff;display: -webkit-box;-webkit-line-clamp: 1;-webkit-box-orient: vertical;overflow: hidden;text-overflow: ellipsis;line-height: 2rem;}
	.VideoUserBoxname span{display: inline-block;position: absolute;line-height: 1.1rem;padding: 0 0.3rem;background: #fff;color: #333;font-size: 0.5rem;right: 0rem;top: 0.5rem;border-radius: 0.8rem;}
	.ViderUserImg img{position: absolute;top: 0px;left: 50%;margin-left: -25px;}
	.OperationList{width: 40%;float: right;margin-top: 0.4rem;}
	.OperationList ul{margin: 0;padding: 0;}
	.OperationList ul li{display: inline-block;width: 33.3%;float: left;text-align: center;}
	.OperationList ul li img{max-height: 1rem;}
	.OperationList ul li:nth-child(3) img{max-height: 1.2rem;}
	.OperationList ul li p{margin: 0;font-size: 0.4rem;line-height: 0.5rem;color: #999;margin-top: 0.1rem;}
	.VideoTitlesBox{width: 100%;box-sizing: border-box;padding: 0.2rem 0.3rem;z-index:9;padding-bottom: 0rem;}
	.VideoHeaderTopTexts{display: inline-block;width: 100%;}
	.VideoTitlesBox h3{font-size: 0.7rem;line-height: 0.9rem;margin: 0;padding: 0;color: #fff;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;overflow: hidden;text-overflow: ellipsis;}
	.VideoHeaderTopTexts p{font-size: 0.7rem;line-height: 0.9rem;margin: 0;padding: 0;color: #fff;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;overflow: hidden;text-overflow: ellipsis;}
	.VideoTitlesBox span{display: inline-block;font-size: 0.7rem;line-height: 0.8rem;margin: 0;padding: 0;margin-top: 0.1rem;color: #ffc107;margin-right: 0.5rem;}
	.VideoTitlesBox p{font-size: 0.7rem;line-height: 0.9rem;margin: 0;padding: 0;color: #fff;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;overflow: hidden;text-overflow: ellipsis;}
	
	.TransparencyBack{display: block;position: fixed;left: 0px;bottom: 0px;z-index: 99;width: 100%;height: 100%;box-sizing: border-box;}
	.VideoCommentBox{display: block;position: fixed;left: 0px;bottom: 0px;z-index: 9999;background: #fff;width: 100%;box-sizing: border-box;box-shadow: 0px -10px 10px #ddd;display: none;}
	.VideoCommentHeader{text-align: center;position: relative;}
	.VideoCommentHeader p{margin: 0;line-height: 0.8rem;font-size: 0.5rem;color: #666;margin-top: 0.4rem;}
	.VideoCommentHeader img{width: 0.9rem;position: absolute;top: -0.2rem;right: 0.2rem;cursor: pointer;z-index: 1000;}
	.VideoCommentListBox{padding: 0.3rem 0rem;}
	.VideoCommentListBox ul{margin: 0;padding: 0.5rem;overflow: auto;height: 200px;}
	.VideoCommentListBox li{margin-top: 0.7rem;}
	.VideoCommentListBox li:nth-child(1){margin-top: 0rem;}
	.CommentHeader{display: inline-block;width: 1.5rem;height: 1.5rem;border-radius: 50%;overflow: hidden;vertical-align: top;}
	.CommentHeader img{max-width: 100%;max-height: 100%;}
	.CommentUserBox{display: inline-block;width: calc(100% - 1.7rem);box-sizing: border-box;padding-left: 0.5rem;}
	.CommentUserBox h6{font-weight: normal;margin: 0;padding: 0;color: #999;font-size: 0.5rem;}
	.CommentUserBox p{font-weight: normal;margin: 0;padding: 0;color: #333;font-size: 0.5rem;line-height: 0.7rem;margin-top: 0.2rem;}
	.CommentInputBox{padding: 0.2rem 0.5rem;border-top: 1px solid #e5e5e5;}
	.CommentInputContent{background-color: #ccc;padding: 3px 0.2rem;border-radius: 1.5rem;position: relative;box-sizing: border-box;overflow: hidden;}
	.CommentInputContent input{display: block;padding: 0 0.2rem;line-height: 1.5rem;box-sizing: border-box;width: 100%;border: none;background: #ccc;padding-right: 3.3rem;}
	.CommentInputContent span{display: inline-block;padding: 0 1rem;background: #FF0000;font-size: 0.6rem;color: #fff;position: absolute;line-height: 1.5rem;right: 3px;top: 3px;z-index: 1000;border-radius: 1.5rem;}
	/*相关产品*/
	.RelatedProductsBox{display: block;background: rgba(255,255,255,1);width: 80%;box-sizing: border-box;border-radius: 0.5rem;}
	.ProductsContentBox{padding: 0.2rem 0.3rem;padding-bottom: 0rem;max-height: 7rem;overflow: auto;}
	.goodslists{padding-bottom: 0.2rem;}
	.ProductsImg{display: inline-block;width: 3rem;height: 3rem;line-height: 2.8rem;overflow: hidden;vertical-align: top;border-radius: 0.3rem;overflow: hidden;}
	.ProductsImg img{width: 100%;}
	.ProductsTextBox{display: inline-block;width: calc(100% - 3.3rem);box-sizing: border-box;padding-left: 0.4rem;vertical-align: top;}
	.ProductsTextBox h3{font-size: 0.7rem;line-height: 0.9rem;margin: 0;padding: 0;color: #000;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;overflow: hidden;text-overflow: ellipsis;min-height: 1.8rem;}
	.ProductsTextBox p{font-size: 0.7rem;line-height: 0.8rem;margin: 0;padding: 0;margin-top: 0.2rem;color: #000;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;overflow: hidden;text-overflow: ellipsis;}
	/*相关视频*/
	.RelatedVideoBox{display: block;position: fixed;left: 0px;bottom: 0px;z-index: 1009;background: #fff;width: 100%;box-sizing: border-box;box-shadow: 0px -10px 10px #ddd;min-height: 8rem;display: none;}
	.RelatedVideoContentBox{padding: 0.2rem 0.3rem;}
	.RelatedVideoContentBox ul{overflow: auto;margin: 0;padding: 0;max-height: 12rem;}
	.RelatedVideoContentBox ul li{border-bottom: 1px solid #ebebeb;padding: 0.3rem 0;}
	.RelatedVideoImg{display: inline-block;width: 3.5rem;height: 3.5rem;line-height: 3.2rem;overflow: hidden;vertical-align: top;}
	.RelatedVideoImg img{width: 100%;}
	.RelatedVideoTextBox{display: inline-block;width: calc(100% - 4.3rem);box-sizing: border-box;padding-left: 0.4rem;vertical-align: top;}
	.RelatedVideoTextBox h3{font-size: 0.7rem;line-height: 1rem;margin: 0;padding: 0;color: #000;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;overflow: hidden;text-overflow: ellipsis;}
	.RelatedVideoTextBox span{display: inline-block;font-size: 0.3rem;line-height: 0.8rem;margin: 0;padding: 0;margin-top: 0.1rem;color: #a37a00;margin-right: 0.5rem;}
	.goauthorization{text-align: center;margin-top: 0.2rem;}
	.goauthorization p{font-size: 0.4rem;color: #888;margin: 0;line-height: 0.7rem;}
	/*视频控件隐藏*/
    video::-webkit-media-controls-fullscreen-button { display: none; } 
    video::-webkit-media-controls-mute-button { display: none; } 
    video::-webkit-media-controls-toggle-closed-captions-button { display: none; } 
    video::-webkit-media-controls-volume-slider {display: none;}
    video::-webkit-media-controls-timeline {
    z-index: 999999999;
}
video::-webkit-media-controls-current-time-display{     
    line-height: 25px;font-size: 12px; 
}

video::-webkit-media-controls-time-remaining-display {
    line-height: 25px;font-size: 12px;            
}
video::-webkit-media-controls-play-button {position: fixed;display: inline-block;width: 3rem;height: 3rem;left: 50%;top: 50%;font-size: 10rem;text-align: center;background-size: 1.5rem;
    background-color: rgba(0,0,0,0.3);background-position: center center;background-repeat: no-repeat;background-size: 1.5rem;border-radius: 50%;margin-top: -1.5rem;margin-left: -1.5rem;}


    .active{display: block;}
</style>